<template>
  <div
    class="floating-card"
    :class="{ 'with-shadow': withShadow, 'with-border': withBorder }"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  withShadow?: boolean;
  withBorder?: boolean;
}

withDefaults(defineProps<Props>(), {
  withShadow: true,
  withBorder: true
});
</script>

<style scoped lang="scss">
.floating-card {
  border-radius: $radius-5;
  padding: $space-3;
  margin-bottom: $space-2;
  text-align: left;
  background-color: $color-neutral-0;
}

.with-shadow {
  box-shadow: $floating-card-shadow;
}

.with-border {
  border: $border;
}

// Styles for big screens
@media (min-height: $small-screen-height) {
  .floating-card {
    padding: $space-4;
    margin-bottom: $space-4;
  }
}
</style>
